import { DELETE_DMX_DEVICE, DELETE_DMX_DEVICE_SUCCESSFUL, DELETE_DMX_DEVICE_FAILED } from './actionTypes';

const initialState = {
  deleteDmxDeviceError: null,
  messageDmxDevice: null,
  loadingDeleteDmxDevice: false,
};

const deleteDevice = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DMX_DEVICE:
      state = { ...state, loadingDeleteDmxDevice: true, deleteDmxDeviceError: null };
      break;
    case DELETE_DMX_DEVICE_SUCCESSFUL:
      state = { ...state, loadingDeleteDmxDevice: false, messageDmxDevice: action.payload, deleteDmxDeviceError: null };
      break;
    case DELETE_DMX_DEVICE_FAILED:
      state = { ...state, messageDmxDevice: null, loadingDeleteDmxDevice: false, deleteDmxDeviceError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteDevice;
